import { useNavigate } from "react-router-dom";

/**
 * Bandeau flottant qui apparaît UNIQUEMENT quand l'utilisateur est en mode démo
 * (localStorage.bobine_is_demo === '1'). Permet de quitter proprement la démo
 * et de restaurer la session réelle si elle a été sauvegardée avant /demo.
 */
const DemoExitBanner = () => {
  const navigate = useNavigate();
  const isDemo = typeof window !== 'undefined' && localStorage.getItem('bobine_is_demo') === '1';
  if (!isDemo) return null;

  const exitDemo = () => {
    const prevToken = localStorage.getItem('bobine_prev_token');
    const prevUser = localStorage.getItem('bobine_prev_user');
    // Wipe demo session
    localStorage.removeItem('bobine_is_demo');
    localStorage.removeItem('bobine_token');
    localStorage.removeItem('bobine_user');
    localStorage.removeItem('bobine_prev_token');
    localStorage.removeItem('bobine_prev_user');
    if (prevToken) {
      // Restaurer la session réelle qui existait avant /demo
      localStorage.setItem('bobine_token', prevToken);
      if (prevUser) localStorage.setItem('bobine_user', prevUser);
    }
    window.dispatchEvent(new Event('bobine-user-updated'));
    navigate(prevToken ? '/dashboard' : '/', { replace: true });
    // Force a hard refresh to ensure all state is clean
    setTimeout(() => window.location.reload(), 50);
  };

  return (
    <div data-testid="demo-exit-banner" style={{
      position: 'fixed',
      top: 12,
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 9998,
      display: 'flex',
      alignItems: 'center',
      gap: 14,
      padding: '8px 16px 8px 18px',
      borderRadius: 24,
      background: 'rgba(0,0,0,0.92)',
      border: '1px solid #D4AF37',
      boxShadow: '0 6px 24px rgba(0,0,0,0.6), 0 0 0 1px rgba(212,175,55,0.15)',
      backdropFilter: 'blur(12px)',
    }}>
      <span style={{
        fontFamily: "'Georgia', serif",
        fontSize: 11,
        color: '#D4AF37',
        fontStyle: 'italic',
        letterSpacing: 0.5,
      }}>
        ✦ Mode Démonstration
      </span>
      <button
        data-testid="demo-exit-btn"
        onClick={exitDemo}
        style={{
          padding: '5px 14px',
          borderRadius: 18,
          border: '1px solid rgba(212,175,55,0.6)',
          background: 'transparent',
          color: '#D4AF37',
          fontFamily: "'Georgia', serif",
          fontSize: 11,
          fontWeight: 600,
          cursor: 'pointer',
          letterSpacing: 0.5,
          transition: 'all 0.2s',
        }}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(212,175,55,0.1)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
      >
        Quitter
      </button>
    </div>
  );
};

export default DemoExitBanner;
